<template>
  <!-- 判定結果作成 -->
  <div id="KenshinReportCreate">
    <div id="container">
      <kenshinNavi v-bind:pageid='"KenshinReportCreate"'></kenshinNavi>
      <div class="kenshinLabelTitle lable">企業検診 判定結果作成</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber"/></td>
            <th>デモ</th>
            <td><select id="demo" v-model="searchConditions.demo"><option></option><option value="false">含まない</option><option value="true">デモのみ</option></select></td>
            <th>機種</th>
            <td><select id="model" v-model="searchConditions.model"><option v-for="device in kenshinDeviceList" :value="device.value" :key="device.value">{{ device.label1 }}</option></select></td>
            <th>依頼元種別</th>
            <td><select id="clientType" v-model="searchConditions.clientType"><option></option><option :value="role.role_corporation">企業</option><option :value="role.role_dealer">ディーラー</option><option :value="role.role_hospital">医療機関</option><option :value="role.role_accommodations">宿泊施設</option></select></td>
          </tr>
          <tr>
            <th>依頼元</th>
            <td><input type="text" id="client" v-model="searchConditions.client"/></td>
            <th>企業名</th>
            <td><input type="text" id="companyName" v-model="searchConditions.companyName"/></td>
            <th>申込日</th>
            <td colspan="3"><input type="date" id="applicationDateStart" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" id="applicationDateEnd" v-model="searchConditions.applicationDateEnd"/></td>
          </tr>
          <tr>
            <th>判定結果</th>
            <td><select id="judgmentResult" v-model="searchConditions.judgmentResult"><option :value="false">未送付のみ</option><option :value="true">送付済みを含む</option></select></td>
            <th>判定有無</th>
            <td><select id="judgementFlag" v-model="searchConditions.judgementFlag"><option value=""></option><option value="0">無</option><option value="1">有</option></select></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div v-if="hasResult">
        <div class="labelTitle lable">判定結果 inシート</div>
        <div style="display:flex;">
          <div class="reportInArea box">
            <div>
              <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('reportInA')">クリップボードにコピー</b-button>
            </div>
            <div class="tableScroll-area">
              <b-table id="reportInA" :data="data.judgmentResultInSheetA">
                <template slot-scope="props">
                  <b-table-column field="judgmentCode" label="番号" width="10" centered>{{props.row.judgmentCode}}</b-table-column>
                  <b-table-column field="judgmentInstitution" width="120" label="判定機関" >{{props.row.judgmentInstitution}}</b-table-column>
                  <b-table-column field="judgmentDocter" width="120" label="判定医">{{props.row.judgmentDocter}}
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
          <div style="width:10px;"></div>
          <div class="reportInArea box">
            <div>
              <b-button v-if="isWP" class="clipboadCopyButton is-primary" @click="clipboardCopy('reportInB_WP')">クリップボードにコピー</b-button>
              <b-button v-else class="clipboadCopyButton is-primary" @click="clipboardCopy('reportInB')">クリップボードにコピー</b-button>
            </div>
            <div class="tableScroll-area">
              <b-table v-if="isWP" id="reportInB_WP" :data="data.judgmentResultInSheetB">
                <template slot-scope="props">
                  <b-table-column field="index" label="番号" width="100" centered>{{props.index + 1}}</b-table-column>
                  <b-table-column field="client" label="依頼業者" width="500">{{props.row.client}}</b-table-column>
                  <b-table-column field="resultVote" label="結果票" width="100">1</b-table-column>
                  <b-table-column field="judgmentTypeNotation" label="判定種表記" width="1000">A：正常範囲 B：要観察 C：要精密検査 Z：要治療 R：判定不能</b-table-column>
                  <b-table-column field="judgmentTypeList" label="判定種一覧" width="1000">A：正常範囲 B：要観察 C：要精密検査 Z：要治療 R：判定不能</b-table-column>
                  <b-table-column field="address1" label="住所１" width="500">{{props.row.address1}}</b-table-column>
                  <b-table-column field="address2" label="住所２" width="500">{{props.row.address2}}</b-table-column>
                  <b-table-column field="tel" label="TEL" width="150">{{props.row.tel}}</b-table-column>
                  <b-table-column field="fax" label="FAX" width="150"></b-table-column>
                  <b-table-column field="judgmentType1" label="　">A</b-table-column>
                  <b-table-column field="judgmentType2" label="判">B</b-table-column>
                  <b-table-column field="judgmentType3" label="定">C</b-table-column>
                  <b-table-column field="judgmentType4" label="種">Z</b-table-column>
                  <b-table-column field="judgmentType5" label="類">R</b-table-column>
                  <b-table-column field="judgmentType6" label="　"></b-table-column>
                </template>
              </b-table>
              <b-table v-else id="reportInB" :data="data.judgmentResultInSheetB">
                <template slot-scope="props">
                  <b-table-column field="index" label="番号" width="70" centered>{{props.index + 1}}</b-table-column>
                  <b-table-column field="client" label="依頼業者" width="500">{{props.row.client}}</b-table-column>
                  <b-table-column field="resultVote" label="結果票" width="100">1</b-table-column>
                  <b-table-column field="judgmentTypeNotation" label="判定種表記" width="1000">A：正常範囲 B：要観察 C：要精密検査 R：判定不能</b-table-column>
                  <b-table-column field="judgmentTypeList" label="判定種一覧" width="1000">A：正常範囲 B：要観察 C：要精密検査 R：判定不能</b-table-column>
                  <b-table-column field="address1" label="住所１" width="700">{{props.row.address1}}</b-table-column>
                  <b-table-column field="address2" label="住所２" width="700">{{props.row.address2}}</b-table-column>
                  <b-table-column field="tel" label="TEL" width="150">{{props.row.tel}}</b-table-column>
                  <b-table-column field="fax" label="FAX" width="150"></b-table-column>
                  <b-table-column field="judgmentType1" label="　">A</b-table-column>
                  <b-table-column field="judgmentType2" label="判">B</b-table-column>
                  <b-table-column field="judgmentType3" label="定">C</b-table-column>
                  <b-table-column field="judgmentType4" label="種">R</b-table-column>
                  <b-table-column field="judgmentType5" label="類"></b-table-column>
                  <b-table-column field="judgmentType6" label="　"></b-table-column>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div class="labelTitle lable" style="margin-bottom:10px;">判定結果 dataシート</div>
        <div>
          <b-button v-if="isWP" class="clipboadCopyButton is-primary" @click="clipboardCopy('reportData_WP')">クリップボードにコピー</b-button>
          <b-button v-else-if="isSimonJ" class="clipboadCopyButton is-primary" @click="clipboardCopy('reportData_SJ')">クリップボードにコピー</b-button>
          <b-button v-else class="clipboadCopyButton is-primary" @click="clipboardCopy('reportData')">クリップボードにコピー</b-button>
        </div>
        <div class="tableScroll-area2" v-if="isWP">
          <b-table id="reportData_WP" :data="data.judgmentResultDataSheet">
            <template slot-scope="props">
              <b-table-column field="inspectionId" label="検査ID" width="70" sortable centered >{{props.row.inspectionId}}</b-table-column>
              <b-table-column field="employeeNo" label="社員番号ID" width="70" sortable centered >{{props.row.employeeNo}}</b-table-column>
              <b-table-column field="name" label="名前" width="150" sortable centered >{{props.row.name}}</b-table-column>
              <b-table-column field="judgment" label="判定" width="10" sortable centered >{{props.row.judgment}}</b-table-column>
              <b-table-column field="judgmentDate" label="判定日" width="40" sortable centered >{{props.row.judgmentDate}}</b-table-column>
              <b-table-column field="judgmentDocterCode" label="判定医コード" width="40" sortable centered >{{props.row.judgmentDocterCode}}</b-table-column>
              <b-table-column field="gender" label="性別" width="10" sortable centered >{{props.row.gender}}</b-table-column>
              <b-table-column field="birthday" label="生年月日" width="40" sortable centered >{{props.row.birthday}}</b-table-column>
              <b-table-column field="age" label="年齢" width="10" sortable centered >{{props.row.age}}</b-table-column>
              <b-table-column field="height" label="身長" width="60" sortable centered >{{props.row.height}}</b-table-column>
              <b-table-column field="weight" label="体重" width="60" sortable centered >{{props.row.weight}}</b-table-column>
              <b-table-column field="bmi" label="BMI" width="60" sortable centered >{{props.row.bmi}}</b-table-column>
              <b-table-column field="selfCheck" label="セルフチェック" width="40" sortable centered >{{props.row.selfCheck}}</b-table-column>
              <b-table-column field="enterpriseName" label="事業所" width="200" sortable centered >{{props.row.enterpriseName}}</b-table-column>
              <b-table-column field="startDate" label="開始日" width="60" sortable centered >{{props.row.startDate}}</b-table-column>
              <b-table-column field="startTime" label="開始時間" width="60" sortable centered >{{props.row.startTime}}</b-table-column>
              <b-table-column field="endDate" label="終了日" width="60" sortable centered >{{props.row.endDate}}</b-table-column>
              <b-table-column field="endTime" label="終了時間" width="60" sortable centered >{{props.row.endTime}}</b-table-column>
              <b-table-column field="measurementTime" label="測定時間" width="60" sortable centered >{{props.row.measurementTime}}</b-table-column>
              <b-table-column field="sleepTime" label="解析時間" width="60" sortable centered >{{props.row.sleepTime}}</b-table-column>
              <b-table-column field="SPO2Center" label="SPO2中央" width="60" sortable centered >{{props.row.SPO2Center}}</b-table-column>
              <b-table-column field="SPO2Minimum" label="SPO2最低" width="60" sortable centered >{{props.row.SPO2Minimum}}</b-table-column>
              <b-table-column field="odi4" label="ODI4" width="60" sortable centered >{{props.row.odi4}}</b-table-column>
              <b-table-column field="rdi" label="RDI" width="60" sortable centered >{{props.row.rdi}}</b-table-column>
              <b-table-column field="ahi" label="AHI" width="60" sortable centered >{{props.row.ahi}}</b-table-column>
              <b-table-column field="pulseAverage" label="脈拍平均" width="60" sortable centered >{{props.row.pulseAverage}}</b-table-column>
              <b-table-column field="pulseLowest" label="脈拍最低" width="60" sortable centered >{{props.row.pulseLowest}}</b-table-column>
              <b-table-column field="oxygenLessThan90" label="酸素90未満" width="60" sortable centered >{{props.row.oxygenLessThan90}}</b-table-column>
              <b-table-column field="oxygenLessThan88" label="酸素88未満" width="60" sortable centered >{{props.row.oxygenLessThan88}}</b-table-column>
              <b-table-column field="oxygenLessThan85" label="酸素85未満" width="60" sortable centered >{{props.row.oxygenLessThan85}}</b-table-column>
              <b-table-column field="oxygenLessThan80" label="酸素80未満" width="60" sortable centered >{{props.row.oxygenLessThan80}}</b-table-column>
              <b-table-column field="oxygenLessThan70" label="酸素70未満" width="60" sortable centered >{{props.row.oxygenLessThan70}}</b-table-column>
              <b-table-column field="snoring40dBRate" label="いびき40dB率" width="60" sortable centered >{{props.row.snoring40dBRate}}</b-table-column>
              <b-table-column field="receiptNumber" label="受付番号" width="70" sortable centered ></b-table-column>
              <b-table-column field="findings" label="所見" width="200" sortable centered >{{props.row.findings}}</b-table-column>
              <b-table-column field="belongs" label="所属" width="10" sortable centered ></b-table-column>
            </template>
          </b-table>
        </div>
        <div class="tableScroll-area2" v-else-if="isSimonJ">
          <b-table id="reportData_SJ" :data="data.judgmentResultDataSheet">
            <template slot-scope="props">
              <b-table-column field="inspectionId" label="患者ID" width="70" sortable centered >{{props.row.inspectionId}}</b-table-column>
                <b-table-column field="name" label="名前" width="150" sortable centered >{{props.row.name}}</b-table-column>
                <b-table-column field="applicationDate" label="申込日" width="40" sortable centered >{{props.row.applicationDate}}</b-table-column>
                <b-table-column field="judgment" label="判定" width="10" sortable centered >{{props.row.judgment}}</b-table-column>
                <b-table-column field="judgmentDate" label="判定日" width="40" sortable centered >{{props.row.judgmentDate}}</b-table-column>
                <b-table-column field="judgmentDocterCode" label="判定医コード" width="40" sortable centered >{{props.row.judgmentDocterCode}}</b-table-column>
                <b-table-column field="gender" label="性別" width="10" sortable centered >{{props.row.gender}}</b-table-column>
                <b-table-column field="birthday" label="生年月日" width="40" sortable centered >{{props.row.birthday}}</b-table-column>
                <b-table-column field="age" label="年齢" width="10" sortable centered >{{props.row.age}}</b-table-column>
                <b-table-column field="height" label="身長" width="60" sortable centered >{{props.row.height}}</b-table-column>
                <b-table-column field="weight" label="体重" width="60" sortable centered >{{props.row.weight}}</b-table-column>
                <b-table-column field="bmi" label="BMI" width="60" sortable centered >{{props.row.bmi}}</b-table-column>
                <b-table-column field="selfCheck" label="セルフチェック" width="40" sortable centered >{{props.row.selfCheck}}</b-table-column>
                <b-table-column field="enterpriseName" label="施設名" width="200" sortable centered >{{props.row.enterpriseName}}</b-table-column>
                <b-table-column field="startDate" label="測定日" width="60" sortable centered >{{props.row.startDate}}</b-table-column>
                <b-table-column field="startTime" label="開始時刻" width="60" sortable centered >{{props.row.startTime}}</b-table-column>
                <b-table-column field="measurementTime" label="測定時間" width="60" sortable centered >{{props.row.measurementTime}}</b-table-column>
                <b-table-column field="startTime" label="解析時間" width="60" sortable centered >{{props.row.analysisTime}}</b-table-column>
                <b-table-column field="odi4" label="ODI3" width="60" sortable centered >{{props.row.odi3}}</b-table-column>
                <b-table-column field="SPO2Center" label="SPO2平均値" width="60" sortable centered >{{props.row.SPO2Center}}</b-table-column>
                <b-table-column field="SPO2Minimum" label="SPO2最低値" width="60" sortable centered >{{props.row.SPO2Minimum}}</b-table-column>
                <b-table-column field="SPO2Minimum" label="SPO2低下数" width="60" sortable centered >{{props.row.SPO2Declines}}</b-table-column>
                <b-table-column field="pulseAverage" label="脈拍平均" width="60" sortable centered >{{props.row.pulseAverage}}</b-table-column>
                <b-table-column field="employeeNo" label="社員番号" width="70" sortable centered >{{props.row.employeeNo}}</b-table-column>
                <b-table-column field="findings" label="所見" width="200" sortable centered >{{props.row.findings}}</b-table-column>
                <b-table-column field="belongs" label="所属" width="10" sortable centered ></b-table-column>
            </template>
          </b-table>
        </div>
        <div class="tableScroll-area2" v-else>
          <b-table id="reportData" :data="data.judgmentResultDataSheet">
            <template slot-scope="props">
              <b-table-column field="inspectionId" label="検査ID" width="70" sortable centered >{{props.row.inspectionId}}</b-table-column>
              <b-table-column field="name" label="名前" width="150" sortable centered >{{props.row.name}}</b-table-column>
              <b-table-column field="applicationDate" label="申込日" width="40" sortable centered >{{props.row.applicationDate}}</b-table-column>
              <b-table-column field="judgment" label="判定" width="10" sortable centered >{{props.row.judgment}}</b-table-column>
              <b-table-column field="judgmentDate" label="判定日" width="40" sortable centered >{{props.row.judgmentDate}}</b-table-column>
              <b-table-column field="judgmentDocterCode" label="判定医コード" width="40" sortable centered >{{props.row.judgmentDocterCode}}</b-table-column>
              <b-table-column field="gender" label="性別" width="10" sortable centered >{{props.row.gender}}</b-table-column>
              <b-table-column field="birthday" label="生年月日" width="40" sortable centered >{{props.row.birthday}}</b-table-column>
              <b-table-column field="age" label="年齢" width="10" sortable centered >{{props.row.age}}</b-table-column>
              <b-table-column field="height" label="身長" width="60" sortable centered >{{props.row.height}}</b-table-column>
              <b-table-column field="weight" label="体重" width="60" sortable centered >{{props.row.weight}}</b-table-column>
              <b-table-column field="bmi" label="BMI" width="60" sortable centered >{{props.row.bmi}}</b-table-column>
              <b-table-column field="selfCheck" label="セルフチェック" width="40" sortable centered >{{props.row.selfCheck}}</b-table-column>
              <b-table-column field="enterpriseName" label="事業所" width="200" sortable centered >{{props.row.enterpriseName}}</b-table-column>
              <b-table-column field="startDate" label="開始日" width="60" sortable centered >{{props.row.startDate}}</b-table-column>
              <b-table-column field="startTime" label="開始時間" width="60" sortable centered >{{props.row.startTime}}</b-table-column>
              <b-table-column field="endDate" label="終了日" width="60" sortable centered >{{props.row.endDate}}</b-table-column>
              <b-table-column field="endTime" label="終了時間" width="60" sortable centered >{{props.row.endTime}}</b-table-column>
              <b-table-column field="measurementTime" label="測定時間" width="60" sortable centered >{{props.row.measurementTime}}</b-table-column>
              <b-table-column field="sleepTime" label="解析時間" width="60" sortable centered >{{props.row.sleepTime}}</b-table-column>
              <b-table-column field="SPO2Center" label="SPO2中央" width="60" sortable centered >{{props.row.SPO2Center}}</b-table-column>
              <b-table-column field="SPO2Minimum" label="SPO2最低" width="60" sortable centered >{{props.row.SPO2Minimum}}</b-table-column>
              <b-table-column field="odi4" label="ODI4" width="60" sortable centered >{{props.row.odi4}}</b-table-column>
              <b-table-column field="odi3" label="ODI3" width="60" sortable centered >{{props.row.odi3}}</b-table-column>
              <b-table-column field="odi2" label="ODI2" width="60" sortable centered >{{props.row.odi2}}</b-table-column>
              <b-table-column field="lessThan90Time" label="<90%時間" width="60" sortable centered >{{props.row.oxygenLess90Time}}</b-table-column>
              <b-table-column field="lessThan90Ratio" label="<90%割合" width="60" sortable centered >{{props.row.oxygenLess90Ratio}}</b-table-column>
              <b-table-column field="pulseAverage" label="脈拍中央" width="60" sortable centered >{{props.row.pulseAverage}}</b-table-column>
              <b-table-column field="employeeNo" label="社員番号" width="70" sortable centered >{{props.row.employeeNo}}</b-table-column>
              <b-table-column field="findings" label="所見" width="200" sortable centered >{{props.row.findings}}</b-table-column>
              <b-table-column field="belongs" label="所属" width="10" sortable centered ></b-table-column>
            </template>
          </b-table>
        </div>
        <div class="button-area">
            <b-button class="reportSendButton is-primary" v-on:click="sendResult">判定結果送付済み</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/kenshin/KenshinNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
import {role} from "@/components/mock/base/const.js";

export default {
  name: "KenshinReportCreate",
  methods: {
    doSearch: function() {
      this.data = []
      this.hasResult = false;
      if(!this.searchConditions.model){
        // 機種が未選択の場合
        this.showErrorMessage("機種を選択してください")
        return;
      }
      var excuteApi = this.getKenshinJudgmentResultListPOST;
      var successCallBack = this.getKenshinJudgmentResultListPOSTSuccess;
      var errorCallBack = this.getKenshinJudgmentResultListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinJudgmentResultListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      if(!obj.clientType){
        delete obj.clientType
      }
      return client.apis.internalKenshin.getKenshinJudgmentResultListPOST({
        body:obj
      });
    },
    getKenshinJudgmentResultListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      var model = this.kenshinDeviceList.find(val => val.value == this.searchConditions.model)
      this.isWP = false
      this.isSimonJ = false
      if(model && model.label1.indexOf("ウォッチパット") != -1){
        this.isWP = true
      }else if(model && model.label1.indexOf("サイモンJ") != -1){
        this.isSimonJ = true
      }
      if(this.data.judgmentResultDataSheet.length>0){
        this.hasResult = true;
      }
    },
    getKenshinJudgmentResultListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tableWrapper = btable.getElementsByClassName("table-wrapper")[0];
      var table = tableWrapper.getElementsByTagName("table")[0];
      var tbody = table.getElementsByTagName("tbody")[0];
      navigator.clipboard
        .writeText(tbody.innerText)
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    sendResult: function() {
      var excuteApi = this.setKenshinJudgmentResultSendPOST;
      var successCallBack = this.setKenshinJudgmentResultSendPOSTSuccess;
      var errorCallBack = this.setKenshinJudgmentResultSendPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setKenshinJudgmentResultSendPOST: function(client) {
      var obj = this.data.judgmentResultDataSheet.map(val => val.receiptNumber)
      return client.apis.internalKenshin.setKenshinJudgmentResultSendPOST({
        body:{receiptNumber:obj}
      });
    },
    setKenshinJudgmentResultSendPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = {}
      this.hasResult = false;
      this.showSuccess(result);
    },
    setKenshinJudgmentResultSendPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    return {
      kenshinDeviceList,
      role: role,
      searchConditions:{
        receiptNumber:"",
        demo:"",
        model:kenshinDeviceList[0].value,
        clientType:"",
        client:"",
        companyName:"",
        applicationDateStart:"",
        applicationDateEnd:"",
        judgmentResult:false,
        judgmentFlag:""
      },
      data: {},
      checkedRows: [],
      isPaginated: true,
      hasResult: false,
      isWP:false,
      isSimonJ:false,
      judgmentTypeList:""
    };
  },
  filters: {},
  components: {
    kenshinNavi: naviBar
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width: 100px;
}
.reportInArea {
  width:600px;
  height:400px;
}
#reportData,
#reportData_WP,
#reportData_SJ{
  width:6000px;
}
#reportInB{
  width:2200px;
}
#reportInB_WP{
  width:2200px;
}
#reportInA {
  width:600px;
}
#reportInA tbody tr td,
#reportInB tbody tr td,
#reportInB_WP tbody tr td,
#reportData tbody tr td,
#reportData_WP tbody tr td,
#reportData_SJ tbody tr td{
  word-break : break-all;
}

.tableScroll-area
{
  clear: both;
  max-height: 330px;
  max-width:  580px;
  overflow:auto;
}
.tableScroll-area2{
  clear: both;
  max-height: 600px;
  overflow: scroll;
}
.reportSendButton {
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinReportCreate.vue